(() => {
  const SELECTORS = [
    'a.custom-nav-header__right-icon[href*="/cart"]',
    'a.custom-nav-mobile-bar__right-icon[href*="/cart"]',
    "#cart-icon-bubble",
    "a.wt-cart__trigger",
  ].join(",");

  const cartIconLinks = () => document.querySelectorAll(SELECTORS);

  const ensureBadge = (link) => {
    let badge = link.querySelector(".stm-cart-count");
    if (!badge) {
      badge = document.createElement("span");
      badge.className = "stm-cart-count";
      badge.setAttribute("aria-hidden", "true");
      link.appendChild(badge);
    }
    let num = badge.querySelector(".stm-cart-count__num");
    if (!num) {
      num = document.createElement("span");
      num.className = "stm-cart-count__num";
      badge.textContent = "";
      badge.appendChild(num);
    }
    return badge;
  };

  const visibleItemCount = (cart) => {
    if (!cart || !Array.isArray(cart.items)) {
      return Number(cart && cart.item_count) || 0;
    }
    return cart.items.reduce((sum, item) => {
      if (item.handle === "gift-wrap-1") return sum;
      return sum + (Number(item.quantity) || 0);
    }, 0);
  };

  const updateBadges = (count) => {
    const n = Number(count) || 0;
    cartIconLinks().forEach((link) => {
      if (n > 0) {
        const badge = ensureBadge(link);
        const num = badge.querySelector(".stm-cart-count__num");
        num.textContent = n > 99 ? "99+" : String(n);
        badge.removeAttribute("hidden");
        link.setAttribute(
          "aria-label",
          n === 1 ? "Cart, 1 item" : `Cart, ${n} items`,
        );
      } else {
        const badge = link.querySelector(".stm-cart-count");
        if (badge) badge.remove();
        link.setAttribute("aria-label", "Cart");
      }
    });
  };

  let refreshTimer;
  const refreshCartCount = () => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then((response) => response.json())
        .then((cart) => updateBadges(visibleItemCount(cart)))
        .catch(() => {});
    }, 50);
  };

  updateBadges(window.stmCartCount || 0);

  if (typeof subscribe === "function" && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCartCount);
  }

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const request = args[0];
    const url =
      typeof request === "string"
        ? request
        : request && request.url
          ? request.url
          : "";
    return originalFetch.apply(this, args).then((response) => {
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        refreshCartCount();
      }
      return response;
    });
  };
})();
